export default class RateApp {
	constructor(options) {
		const appName = options.appName || 'App';
		const ios = options.ios || null;
		const android = options.android || null;
		const windows = options.windows || null;
		const web = options.webRateURL || "https://cardsjd.com";
		const amazon = options.amazon || null;
		const email = options.email || 'jimmy@jdsoftwarellc.com';
		const emailSubject = options.emailSubject || appName + ' Feedback';
		const os = options.os || this.getOS();

		this.os = os;
		this.appName = appName;
		this.ios = ios;
		this.iosUrl = 'itms-apps://itunes.apple.com/app/' + ios;
		this.android = 'market://details?id=' + android;
		this.amazon = 'amzn://apps/android?asin=' + amazon;
		this.windows = 'ms-windows-store://pdp/?ProductId=' + windows;
		this.webURl = web;
		this.email = 'mailto:' + email + '?subject=' + emailSubject;
	}

	rate() {
		// //try native rate
		// let rated = this.rateNative();
		// if (rated) return true;

		return this.rateNonNative();
	}

	rateNative() {
		//rate app natively
		if (typeof cordova !== 'undefined' && globalThis.cordova.plugins && globalThis.cordova.plugins.RateAppNative && globalThis.cordova.plugins.RateAppNative.rate) {
			globalThis.cordova.plugins.RateAppNative.rate();
		}
	}

	rateNonNative() {
		let os = this.os;

		if (!os) {
			os = this.getOS();
		}

		if (os === 'android') {
			window.open(this.android, '_system');
			return true;
		}

		if (os === 'ios') {
			window.open(this.iosUrl, '_system');
			return true;
		}

		if (os === 'amazon') {
			window.open(this.amazon, '_system');
			return true;
		}

		if (os === 'windows') {
			window.open(this.windows, '_system');
			return true;
		}
		if (os === 'web') {
			window.open(this.webURl, '_system');
			return true;
		}
	}

	getOS() {
		const ua = navigator.userAgent;
		const isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

		if (typeof FBInstant !== 'undefined') {
			if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
				return 'FBInstantiOS'; //used to not show more games on fb ios
			}else{
				return 'FBInstant';
			}
		}

		if (/(android)/i.test(navigator.userAgent) && isKindle) {
			return 'amazon';
		} 
		if (/(android)/i.test(navigator.userAgent) && !isKindle) {
			return 'android';
		} 
		if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
			return 'ios';
		}
		if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
			// Windows 10 UWP
			return 'windows';
		}
		//pwa + edg = Edge
		const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
		if (isInStandaloneMode && /(Edg)/i.test(navigator.userAgent)) {
			return 'windows';
		}

		return "web";
	}
}
